import { render, staticRenderFns } from "./mallHome.vue?vue&type=template&id=90fe61de&scoped=true"
import script from "./mallHome.vue?vue&type=script&lang=js"
export * from "./mallHome.vue?vue&type=script&lang=js"
import style0 from "./mallHome.vue?vue&type=style&index=0&id=90fe61de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fe61de",
  null
  
)

export default component.exports